import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";

import { AUTHORIZATION } from "../../../constants/api/auth";
import { MESSAGE } from "../../../constants/api/message";

const { get } = request;
const initialRoute = "employer";
const { Authorization, Bearer } = AUTHORIZATION;

export const getPremiumRecalculation = async (filterQuery: any) => {
	try {
		const endpoint = `${initialRoute}/premium-recalculation/get-premium-recalculation`;
		const token = localStorage.getItem("@jwt");
		const response = await get(
			endpoint,
			{
				...headers,
				[Authorization]: `${Bearer} ${token}`
			},
			filterQuery
		);

		// console.log("DEBUG----------------(7)", response);

		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
